import { BaseResponse } from '../../../../../../types/api/api.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';

const PREFIX = '[deleteAccountQuery]';

export const DELETE_ACCOUNT_QUERY_KEY = 'DELETE_ACCOUNT';

export const deleteAccountQuery = async () => {
  console.log(PREFIX, `Requesting remove account...`);

  const response = await AUTH_ENDPOINTS.deleteUser();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received remove account.`);
  return json as BaseResponse;
};
